import { ValueFormatterParams } from 'ag-grid-community';
import { formatValue, getFixedPrecision, getFormat, NumeralType, NumeralTypes } from '@common/utils/formatNumberValue';

type CustomNumberFormatterParams = {
  hideDecimals?: boolean,
  negativeMinus?: boolean,
  suppressHidingDecimalPlaces?: boolean,
  shouldDisplayZero?: boolean,
  type?: NumeralType,
}

const percentageFormats: string[] = [
  NumeralTypes.PERCENTAGE,
  NumeralTypes.PERCENT_2,
  NumeralTypes.PERCENT_4,
];

export const customNumberFormatter = ({
  hideDecimals,
  negativeMinus,
  suppressHidingDecimalPlaces,
  shouldDisplayZero,
  type = NumeralTypes.NUMBER,
}: CustomNumberFormatterParams) => ({ value }: ValueFormatterParams): string => {
  if (!shouldDisplayZero && (value === '0' || value === '-')) {
    return '-';
  }
  const decimalFormat = hideDecimals && !suppressHidingDecimalPlaces ? '0,0' : getFormat(type);
  const decimalOrPercentageFormat
    = percentageFormats.includes(type)
      ? `${decimalFormat}%`
      : decimalFormat;
  const customFormat = negativeMinus ? `-${decimalOrPercentageFormat}` : `(${decimalOrPercentageFormat})`;
  const fixedPrecision = hideDecimals && !suppressHidingDecimalPlaces ? 2 : getFixedPrecision(type);

  const parsedValue = formatValue({
    value,
    type,
    customFormat: customFormat.replace(/,/g, ''),
    fixedPrecision,
    acceptRaw: false,
  });

  if (!shouldDisplayZero && !isNaN(parsedValue as any) && !Number(parsedValue as any)) {
    return '-';
  }

  return formatValue({
    value,
    type,
    customFormat,
    fixedPrecision,
    acceptRaw: false,
  })!;
};
